/*
 * @Author: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @Date: 2022-10-30 11:10:57
 * @LastEditors: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @LastEditTime: 2022-10-30 11:15:24
 * @FilePath: \shared-portal-web\packages\info\src\utils\universalFun.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// 回到顶部
export const scrollTopFun = () => {
  const scrollToTop = target => {
    const el = document.querySelector(target)
    const beginTime = Date.now()
    const beginValue = el.scrollTop
    const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
    const cubic = value => Math.pow(value, 3)
    const easeInOutCubic = value => value < 0.5
      ? cubic(value * 2) / 2
      : 1 - cubic((1 - value) * 2) / 2
    const frameFunc = () => {
      const progress = (Date.now() - beginTime) / 500
      if (progress < 1) {
        el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
        rAF(frameFunc)
      } else {
        el.scrollTop = 0
      }
    }
    rAF(frameFunc)
  }
  scrollToTop('#app .el-scrollbar__wrap')
}
